import React from 'react';
import './App.css';

function Products() {
  return (
    <div className='products'>
      <h1>Products</h1>
    </div>
  );
}

export default Products;
